module.exports = __webpack_public_path__ + "static/media/21ECLAC4.99b24094.jpg";